import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {from, Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {environment} from 'environment';
import { LocalSettingsService } from 'shared/local-settings/local-settings.service';
import {Apptext} from '../model/model';

@Injectable()
export class ApptextRepository {

  constructor(private _http: HttpClient, private localSettingsService: LocalSettingsService) {
  }

  public getApptexts(): Observable<Array<Apptext>> {
    return this._http.get(environment.apptext.getTextsRoute)
      .pipe(map((response) => {
        return <Array<Apptext>> response;
      }));
  }

  public getCachedApptexts(): Observable<Array<Apptext>> {
    return from(this._getCachedApptexts());
  }

  public setCachedApptexts(apptexts: Array<Apptext>): Observable<void> {
    return from(this._setCachedApptexts(apptexts));
  }

  private async _getCachedApptexts(): Promise<Array<Apptext>> {
    return this.localSettingsService.get('apptexts');
  }

  private async _setCachedApptexts(apptexts: Array<Apptext>): Promise<void> {
    this.localSettingsService.set('apptexts', apptexts);
  }
}
